
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-21c9c57d!sass-loader?data=@import \"~assets/styles/base\";@import \"~assets/styles/variables\";@import \"~assets/styles/mixins\";&sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Song.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Song.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-21c9c57d!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Song.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Song.vue
// module id = 306
// module chunks = 2